import axios from '@/libs/api.request'
// 获取全部项目的修改进度
export const getMaterialProject = data => {
  return axios.request({
    url: '/material/query/progress/project',
    data,
    method: 'POST'
  })
}
// 获取单个项目文书信息
export const getMaterialEssaysInfo = data => {
  return axios.request({
    url: '/material/query/essays',
    data,
    method: 'POST'
  })
}
// 获取单个项目的修改进度
export const getMaterialSingleProject = data => {
  return axios.request({
    url: '/material/query/single/progress/project',
    data,
    method: 'POST'
  })
}
// 上传文书
export const subUploadEssay = data => {
  return axios.request({
    url: '/material/upload/essay',
    data,
    method: 'POST'
  })
}
// 上传文书显示的详情
export const getViewDetail = data => {
  return axios.request({
    url: '/material/query/view/detail',
    data,
    method: 'POST'
  })
}
// 材料修改剩余时间
export const getMaterialTimeSchedule = data => {
  return axios.request({
    url: '/material/query/time/schedule',
    data,
    method: 'POST'
  })
}
// 获取cv list
export const getMaterialCVlist = data => {
  return axios.request({
    url: '/material/query/progress/cv',
    data,
    method: 'POST'
  })
}
// 获取rl list
export const getMaterialRLlist = data => {
  return axios.request({
    url: '/material/query/progress/rl',
    data,
    method: 'POST'
  })
}
// 获取单独的cv
export const getMeterialSingleCVList = data => {
  return axios.request({
    url: '/material/query/single/progress/cv',
    data,
    method: 'POST'
  })
}
// 获取单独的Rl
export const getMeterialSingleRLList = data => {
  return axios.request({
    url: '/material/query/single/progress/rl',
    data,
    method: 'POST'
  })
}
// 上传cv
export const subMaterialUploadCv = data => {
  return axios.request({
    url: '/material/upload/cv',
    data,
    method: 'POST'
  })
}
// 上传rl
export const subMaterialUploadRl = data => {
  return axios.request({
    url: '/material/upload/rl',
    data,
    method: 'POST'
  })
}
// 材料查询接口
export const getMaterialQueryDeadlineList = data => {
  return axios.request({
    url: '/material/query/deadline/list',
    data,
    method: 'POST'
  })
}
// 文书列表
export const getMaterialQueryDeadlineEssay = data => {
  return axios.request({
    url: '/material/query/deadline/essay',
    data,
    method: 'POST'
  })
}
// 文书列表
export const getMaterialQueryDeadlineCvRl = data => {
  return axios.request({
    url: '/material/query/deadline/cvrl',
    data,
    method: 'POST'
  })
}
